import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TransformationSection } from '../components/TransformationSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { SectionDivider } from '../components/ui/SectionDivider';
import { ScrollProgress } from '../components/ui/ScrollProgress';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream font-sans text-charcoal selection:bg-rose selection:text-charcoal-light overflow-x-hidden" data-id="element-322">
      <ScrollProgress data-id="element-323" />

      <HeroSection data-id="element-324" />
      <SectionDivider topColor="bg-cream-light" bottomColor="text-cream" data-id="element-325" />

      <ProblemSection data-id="element-326" />
      <SectionDivider topColor="bg-cream" bottomColor="text-rose-light" data-id="element-327" />

      <MethodSection data-id="element-328" />
      <SectionDivider topColor="bg-rose-light" bottomColor="text-cream-dark" data-id="element-329" />

      <OfferSection data-id="element-330" />
      <SectionDivider topColor="bg-cream-dark" bottomColor="text-cream" data-id="element-331" />

      <AudienceSection data-id="element-332" />
      <SectionDivider topColor="bg-cream" bottomColor="text-white" data-id="element-333" />

      <HowItWorksSection data-id="element-334" />
      <SectionDivider topColor="bg-white" bottomColor="text-cream-dark" data-id="element-335" />

      <TransformationSection data-id="element-336" />
      <SectionDivider topColor="bg-cream-dark" bottomColor="text-cream-light" data-id="element-337" />

      <PricingSection data-id="element-338" />
      <SectionDivider topColor="bg-cream-light" bottomColor="text-cream" data-id="element-339" />

      <GuaranteeSection data-id="element-340" />
      <SectionDivider topColor="bg-cream" bottomColor="text-burgundy-dark" data-id="element-341" />

      <FinalCTASection data-id="element-342" />

      <Footer data-id="element-343" />
    </main>;
}